import { makeBreadcrumbs } from '../constants';

export default ({ job, isNew }) => {
  const breadcrumbs = makeBreadcrumbs(job);

  const title = 'View Data';
  const loading = !isNew && !job.id;

  return {
    isNew,
    title,
    breadcrumbs,
    loading,
  };
};
